import { render } from "./CompletionAlert.vue?vue&type=template&id=2f0cfbd4"
import script from "./CompletionAlert.vue?vue&type=script&lang=js"
export * from "./CompletionAlert.vue?vue&type=script&lang=js"
script.render = render

export default script